import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {BLOCK_CATEGORY_TILES} from '@EmailMakerReact/lib/email-maker-tile-meta-library';
import {SKELETON_ICON_SIZE, SKELETON_LABEL_HEIGHT, SKELETON_LABEL_WIDTH} from './block-manager-skeleton.types';
import styles from './block-manager-skeleton.module.scss';

/** Sized to the real block manager so the canvas doesn't shift when the live blocks mount. */
export function BlockManagerSkeleton(): ReactElement {
  return (
    <div aria-hidden className={styles.card}>
      {BLOCK_CATEGORY_TILES.map((tile) => (
        <div key={tile.id} className={styles.block}>
          <SkeletonBrick width={SKELETON_ICON_SIZE} height={SKELETON_ICON_SIZE} radius="8px" />
          <SkeletonBrick width={SKELETON_LABEL_WIDTH} height={SKELETON_LABEL_HEIGHT} />
        </div>
      ))}
    </div>
  );
}
